"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const http_1 = require("../http");
const deleteContactCommentary = ({ axios, contactId, commentaryId }) => http_1.httpDelete({
    axios,
    url: `contacts/${contactId}/commentaries/${commentaryId}`
});
exports.default = deleteContactCommentary;
